import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var prefix = "sfx-react-ui";
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';


function InputList(props) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      itemText = _useState2[0],
      setItemText = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      list = _useState4[0],
      setList = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showList = _useState6[0],
      setShowList = _useState6[1];

  var getValueList = useCallback(function (itemText) {
    axios.get(props.url, {
      params: props.getParams(itemText)
    }).then(function (res) {
      var listArr = res.data.results.length > 0 ? res.data.results.map(function (r) {
        var value = props.getValue(r);
        var label = props.getLabel(r);
        return {
          value: value,
          label: label
        };
      }) : [];
      setShowList(listArr.length > 0);
      setList(listArr);
    });
  }, [props]);
  useEffect(function () {
    props.defaultValue && setItemText(props.defaultValue);
  }, [props.defaultValue]);
  useEffect(function () {
    if (!props.defaultValue && props.initValue) {
      getValueList(props.initValue);
    }
  }, [props, getValueList]);

  var selectItem = function selectItem(item) {
    setShowList(false);

    if (props.onSelect) {
      setItemText(item.label);
      props.onSelect(item);
    }
  };

  var hideList = function hideList() {
    setTimeout(function () {
      setShowList(false);
    }, 200);
  };

  var showAddressList = function showAddressList() {
    getValueList(itemText);
  };

  var inputItem = function inputItem(event) {
    setItemText(event.target.value);
    var item = {
      label: event.target.value,
      value: ''
    };
    props.onSelect && props.onSelect(item);

    if (event.target.value === '') {
      return;
    }

    getValueList(event.target.value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-input-list-main")
  }, /*#__PURE__*/React.createElement("input", {
    placeholder: props.placeholder,
    autoComplete: "off",
    type: "text",
    name: "location",
    id: "location",
    className: "".concat(prefix, "-input-list-input ").concat(showList ? "".concat(prefix, "-input-list-input-active") : ''),
    value: itemText,
    onFocus: showAddressList,
    onBlur: hideList,
    onChange: inputItem
  }), showList && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-input-list-options")
  }, list.map(function (listItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      title: listItem.label,
      className: "".concat(prefix, "-input-list-option"),
      onClick: function onClick() {
        selectItem(listItem);
      }
    }, listItem.label);
  })));
}

export default InputList;